import { sumBy } from 'lodash'

export function sumCurrencyValues(collection, key) { 
    return sumBy(collection, (item) => parseFloat(item[key])) 
}

export function displayCurrency(amount) {
 const floatAmount = parseFloat(amount)
 return '$' + floatAmount.toFixed(2)
}